<template>
  <select v-model="selectedLocation">  
    <option v-for="l in [...$locations, 'CSS']" :key="l" v-bind:value="l">{{l}}</option>
  </select>
</template>

<script>
export default {
  // mixins: [localstorageMixin],
  // components : {InventoryCRUD},
  name: 'LocationSelector',
  props: ['value'],
  data () { return { 
    selectedLocation: 'RCGB'
    } 
  },
  created: function(){
    this.selectedLocation = this.value;
  },
  watch:{
    value: function(){
      this.selectedLocation = this.value;
    },
    selectedLocation: function(){
      this.$emit('input', this.selectedLocation)
    }
  }
}
</script>
